<template>
	<div class="trend-option-wrap">
		<mt-navbar v-model="selected">
			<mt-tab-item id="1">打赏（{{rewardList.length}}）</mt-tab-item>
			<mt-tab-item id="2" v-if="isComment==1">评论（{{commentList.length}}）</mt-tab-item>
		</mt-navbar>
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1">
				<div class="list reward-list">
					<mt-loadmore :top-method="refreshRewardList" :bottom-method="loadMoreRewardList" :auto-fill="false" ref="loadmoreReward">
					<li v-for="item in rewardList">
						<div class="item-img">
							<img :src="item.avatar"/>
						</div>
						<div class="item-user-info">
							<p class="user-name">
								{{item.nickname}}
								<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
							</p>
							<p class="item-time">{{item.create_time | toDateTime | convertTime("MM月DD日  HH:MM")}}</p>
						</div>
						<div class="item-gift">
							<div class="img-box">
								<img :src="item.girft_img_url" alt="" />
							</div>
							<mt-badge size="small" color="#875bf0">&times;{{item.g_nums}}</mt-badge>
						</div>
					</li>
					</mt-loadmore>
					<div class="no-content" v-if="rewardList.length==0">
						<img src="../../assets/img/default/bg_img_empty@2x.png"/>
						<p>(〃'▽'〃)这里空空哒~</p>
					</div>
					<button class="submit-btn">打赏</button>
				</div>
				
			</mt-tab-container-item>
			<mt-tab-container-item id="2">
				<div class="list comment-list">
					<mt-loadmore :top-method="refreshCommentList" :bottom-method="loadMoreCommentList" :auto-fill="false" ref="loadmoreComment">
					<li v-for="item in commentList">
						<div class="item-info">
							<div class="item-img">
								<img :src="item.avatar"/>
							</div>
							<div class="item-user-info">
								<p class="user-name">
									{{item.nickname}}
									<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
									<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
									<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
								</p>
								<p class="item-time">{{item.update_time | toDateTime | convertTime("MM月DD日  HH:MM")}}</p>
							</div>
							<div class="item-good">
								<span @click="replyComment(item.t_c_id,item.uid)">
									<img src="../../assets/img/trends/dyn_dyn_ic_message_nor.png"/>
								</span>
								<span @click="submitCommentGood(item.t_c_id,item.good)">
									<img v-if="item.good==0" src="../../assets/img/trends/dyn_dyn_ic_like_nor.png"/>
									<img v-else src="../../assets/img/trends/dyn_dyn_ic_like_pre.png"/>
									{{item.good==0?'':item.good}}
								</span>
							</div>
						</div>
						<div class="item-content">
							<p class="comment-lv1">{{item.text}}</p>
							<div class="comment-lv2-list" v-if="item.sub.length>0">
								<p v-for="i in item.sub"><span class="list-a">{{i.nickname}}</span>回复<span class="list-b">{{i.other_nickname}}</span>:{{i.text}}</p>
							</div>
						</div>
					</li>
					</mt-loadmore>
					<div class="no-content" v-if="commentList.length==0">
						<img src="../../assets/img/default/bg_img_empty@2x.png"/>
						<p>(〃'▽'〃)这里空空哒~</p>
					</div>
					<div class="comment-btn">
						<input class="submit-comment" type="text" placeholder="快来写下你的评论吧~"  v-model="commentValue" ref="commentInput"/>
						<button class="submit-comment-btn" @click="submitComment">提交</button>
					</div>
					
				</div>
			</mt-tab-container-item>
			
		</mt-tab-container>
	</div>
</template>

<script>
	export default{
		name:"trend-option",
		props:["uid","did","oid","isComment","nums"],	//oid当前动态的uid
		data(){
			return{
				selected:"1",
				commentList:[],
				nowCommentPage:1,
				rewardList:[],
				nowRewardPage:1,
				commentType:0,	//0对动态评论，1对动态的评论进行评论，2回复动态的评论
				cid:"",		//评论的id
				cuid:"",	//评论的uid
				commentValue:"",	//评论内容
			}
		},
		created(){
			this.getCommentList();
			this.getRewardList();
		},
		methods:{
			getCommentList(){
				this.$axios({
					url:"Dynamic/TreeHoleCommentList",
					method:"post",
					data:{
						uid:this.uid,
						t_id:this.did,
						page:this.nowCommentPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowCommentPage==1){
							this.commentList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowCommentPage--;
							}else{
								this.commentList = this.commentList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowCommentPage--;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getRewardList(){
				this.$axios({
					url:"Dynamic/getTreeHoleRewardList",
					method:"post",
					data:{
						t_id:this.did,
						page:this.nowRewardPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowRewardPage==1){
							this.rewardList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowRewardPage--;
							}else{
								this.rewardList = this.rewardList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowRewardPage--;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			replyComment(cid,cuid){
				this.commentType = 1;
				this.cid = cid;
				this.cuid = cuid;
				this.$refs.commentInput.focus()
			},
			submitComment(){
				if(this.commentType==0){
					this.$axios({
						url:"Dynamic/InsertTreeHoleComment",
						method:"post",
						data:{
							uid:this.uid,
							t_id:this.did,
							text:this.commentValue
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message: res.data.msg,
								position: "bottom",
								duration: 3000
							});
							this.getCommentList();
							this.commentValue = "";
							this.$emit("refreshData")
						}else{
							this.$toast({
								message: res.data.msg,
								position: "bottom",
								duration: 3000
							});
						}
						
					}).catch(err=>{
						console.log(err);
						this.$toast({
							message: "操作失败！",
							position: "bottom",
							duration: 3000
						});
					})
				}else if(this.commentType==1){
					this.$axios({
						url:"Dynamic/InsertTreeHoleCommentSub",
						method:"post",
						data:{
							uid:this.uid,
							t_clid:this.cid,
							other_uid:this.cuid,
							text:this.commentValue
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message: res.data.msg,
								position: "bottom",
								duration: 3000
							});
							this.getCommentList();
							this.commentValue = "";
							this.commentType = 0;
						}else{
							this.$toast({
								message: res.data.msg,
								position: "bottom",
								duration: 3000
							});
						}
						
					}).catch(err=>{
						console.log(err);
						this.$toast({
							message: "操作失败！",
							position: "bottom",
							duration: 3000
						});
					})
				}
			},
			submitCommentGood(cid,cs){
				console.log(cid,cs);
				let status = cs==0?1:2;
				console.log(status)
				this.$axios({
					url:"Dynamic/TreeHoleCommentGood",
					method:"post",
					data:{
						uid:this.uid,
						other_uid:this.oid,
						t_id:this.did,
						t_clid:cid,
						status:status
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
						this.getCommentList();
					}else{
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
					}
					
				}).catch(err=>{
					console.log(err);
					this.$toast({
						message: "操作失败！",
						position: "bottom",
						duration: 3000
					});
				})
			},
			refreshRewardList(){
				this.nowRewardPage = 1;
				this.getRewardList();
				this.$refs.loadmoreReward.onTopLoaded();
			},
			loadMoreRewardList(){
				this.nowRewardPage ++;
				this.getRewardList();
				this.$refs.loadmoreReward.onBottomLoaded();
			},
			refreshCommentList(){
				this.nowCommentPage = 1;
				this.getCommentList();
				this.$refs.loadmoreComment.onTopLoaded();
			},
			loadMoreCommentList(){
				this.nowCommentPage ++;
				this.getCommentList();
				this.$refs.loadmoreComment.onBottomLoaded();
			},
		}
	}
</script>

<style scoped>
	.mint-navbar .mint-tab-item{
		background: #f3f3f3;
	}
	.mint-navbar .mint-tab-item.is-selected{
		color: #5415F9;
		border-bottom: 0;
		background: #fff;
	}
	.list{
		overflow-y: scroll;
		min-height: 50vh;
	}
	.list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem 1.5rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.comment-list li{
		display: block;
		padding: 0 0 0.5rem;
	}
	.comment-list li .item-info{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem 1.5rem 0.5rem;
	}
	.comment-list li .item-content{
		width: 100%;
		padding-left: 5rem;
		padding-right: 1rem;
	}
	.comment-list .comment-lv1{
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.4rem;
		margin-bottom: 0.5rem;
	}
	.comment-list .comment-lv2-list{
		background: #f3f3f3;
		padding: 0.5rem;
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.4rem;
	}
	.comment-list .comment-lv2-list p span{
		color: #6e9cab;
		padding: 0 0.2rem;
	}
	.list .item-img,.list .item-gift .img-box{
		width: 3rem;
		height: 3rem;
		overflow: hidden;
	}
	.list .item-img img,.list .item-gift img{
		width: 100%;
	}
	.list .item-img{
		border-radius: 50%;
	}
	.list .item-gift{
		position: relative;
	}
	.list .item-gift .mint-badge{
		position: absolute;
		top: -0.5rem;
		right: -0.5rem;
	}
	.list .item-user-info{
		flex: 1;
	}
	.list .item-user-info p{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 0.5rem;
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
	}
	.list .item-user-info p.user-name{
		font-weight: bold;
		color: #282828;
		font-size: 0.9rem;
	}
	.list .item-user-info p.user-name img{
		width: 1.5rem;
		margin-left: 0.25rem;
	}
	.list .submit-btn,.comment-btn{
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		height: 2.6rem;
		border: 0;
		outline: 0;
		background: linear-gradient(to right,#9f7cfc,#baa3fe);
		font-size: 1rem;
		color: #fff;
	}
	.comment-btn{
		background: #fff;
		box-shadow: 0 0 10px #f3f3f3;
		padding: 0.4rem 0.5rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.comment-btn input{
		flex: 1;
		height: 100%;
		font-size: 0.65rem;
		padding: 0 0.5rem;
		color: #282828;
		outline: 0;
		border: 1px solid #eee;
		background: #f4f4f4;
		border-radius: 3px;
	}
	.comment-btn button{
		height: 100%;
		background: #fff;
		color: #5415F9;
		border: 1px solid #5415F9;
		border-radius: 3px;
		margin-left: 0.5rem;
		font-size: 0.65rem;
		outline: 0;
		padding: 0 0.5rem;
	}
	.comment-btn button:active{
		background:#5415F9;
		color: #fff;
	}
	.list .item-good{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.list .item-good span{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #7b7b7b;
		font-size: 0.8rem;
	}
	.list .item-good img{
		width: 1.5rem;
		display: block;
		margin: 0 2px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/TreeDetailOptions.vue